"use client";

import React from "react";
import { ArrowDownRight } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Doctrinal() {
  return <section id="doctrinalhero" data-nav="dark" className="relative w-full min-h-[500px] sm:min-h-[560px] md:min-h-[640px] lg:min-h-[700px] flex items-end overflow-hidden bg-black text-white">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/group_reading_bibles_fellowship.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/group_reading_bibles_fellowship.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1768199/img/group_reading_bibles_fellowship.png-wvc-sizes" alt="Grupo diverso leyendo y estudiando las Sagradas Escrituras en comunidad" className="w-full h-full object-cover object-center" loading="lazy" decoding="async" />
        {}
        <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/50 to-black/30" />
        <div className="absolute inset-0 bg-radial-[circle_at_center,_transparent_40%,_rgba(0,0,0,0.6)_100%]" />
      </div>

      {}
      <div className="relative z-10 w-full px-6 sm:px-10 md:px-16 lg:px-20 py-12 sm:py-16 md:py-20 lg:py-24">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row md:items-end justify-between gap-8">
          {}
          <div className="max-w-3xl space-y-3 sm:space-y-4">
            <span className="inline-block text-xs sm:text-sm font-semibold tracking-widest text-white/90 uppercase">
              DECLARACIÓN DOCTRINAL OFICIAL
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-white leading-[1.1]">
              DECLARACIÓN DE<br className="hidden sm:inline" /> VERDADES FUNDAMENTALES
            </h1>
          </div>

          {}
          <div className="flex shrink-0 items-center self-end md:self-end">
            <Link to="#verdades" aria-label="Desplazarse a las verdades fundamentales" className="group inline-flex items-center justify-center size-12 sm:size-14 bg-white text-black rounded-lg shadow-lg hover:bg-white/90 transition-transform active:scale-95">
              <ArrowDownRight className="size-6 sm:size-7 transition-transform group-hover:translate-x-0.5 group-hover:translate-y-0.5" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}